"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Consumer = exports.Provider = void 0;
const react_1 = require("react");
/**
 * @ignore
 */
const context = (0, react_1.createContext)({ flags: {}, flagKeyMap: {}, ldClient: undefined });
const { 
/**
 * @ignore
 */
Provider, 
/**
 * @ignore
 */
Consumer, } = context;
exports.Provider = Provider;
exports.Consumer = Consumer;
exports.default = context;
//# sourceMappingURL=context.js.map